export const formatTime = (time: string) => time?.slice(0, 2) + ':' + time?.slice(2);
